import { getChromeRuntime } from '../wrappers';
import { ChromeMessageType, TrackingData } from '../../types';

export const getTrackingData = (): Promise<TrackingData> =>
  new Promise(resolve =>
    getChromeRuntime().sendMessage(
      { type: ChromeMessageType.GET_TRACKING_DATA },
      response => resolve(response)
    )
  );
